import { Injectable } from '@angular/core';
import type { DuplicateCheckResult } from './models';

@Injectable()
export class DuplicateCheck {
    public filterDuplicates(
        files: ReadonlyArray<File>,
        existingFiles: ReadonlyArray<File> = []
    ): DuplicateCheckResult {
        if (!files.length) {
            return {
                uniqueFiles: [],
                duplicateNames: [],
            };
        }

        const fingerprint = new Set<string>();

        for (const file of existingFiles) {
            fingerprint.add(this.toFingerprintKey(file));
        }

        const uniqueFiles: File[] = [];
        const duplicateNames: string[] = [];

        for (const file of files) {
            const key = this.toFingerprintKey(file);
            if (fingerprint.has(key)) {
                duplicateNames.push(
                    file.webkitRelativePath?.trim() || file.name
                );
                continue;
            }

            fingerprint.add(key);
            uniqueFiles.push(file);
        }

        return {
            uniqueFiles,
            duplicateNames,
        };
    }

    private toFingerprintKey(file: File): string {
        const relativePath = file.webkitRelativePath?.trim();
        const pathKey =
            relativePath && relativePath.length > 0 ? relativePath : file.name;

        return [
            pathKey.trim().toLowerCase(),
            file.size,
            file.lastModified,
            file.type,
        ].join('::');
    }
}
